import { render, staticRenderFns } from "./EditCurrSessionDialog.vue?vue&type=template&id=11ce521b"
import script from "./EditCurrSessionDialog.vue?vue&type=script&lang=ts"
export * from "./EditCurrSessionDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports